import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import { routes } from './routes'
import VueCarousel from 'vue-carousel';
import VueSweetalert2 from 'vue-sweetalert2';
import { store } from './store/store'
import Meta from 'vue-meta'
import VueWorker from 'vue-worker'
import Vue2TouchEvents from 'vue2-touch-events'
import imagePreloader from 'vue-image-preloader'
import i18n from "@/plugins/i18n"

Vue.use(VueWorker)
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(VueCarousel);
Vue.use(VueSweetalert2);
Vue.use(Meta);
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 60,
})
Vue.use(imagePreloader)

const router = new VueRouter({
  routes,
  mode: 'history'
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})